import { Star, Cloud, Send, Heart, Sparkles, Sun } from "lucide-react";

// Decorative floating doodles. aria-hidden, non-interactive.
export const Doodle = ({ icon: Icon, className = "", style = {}, fill }) => (
  <Icon
    aria-hidden="true"
    className={`pointer-events-none absolute ${className}`}
    style={style}
    fill={fill}
    strokeWidth={2.2}
  />
);

export const DoodleField = () => (
  <>
    <Doodle icon={Star} fill="#FFD93D" className="top-10 left-[6%] text-yellow-400 w-8 h-8 animate-float opacity-80" />
    <Doodle icon={Cloud} fill="#ffffff" className="top-24 right-[10%] text-white w-12 h-12 animate-float opacity-90" style={{ animationDelay: "1s" }} />
    <Doodle icon={Sparkles} className="bottom-20 left-[12%] text-teal-400 w-7 h-7 animate-wiggle" />
    <Doodle icon={Send} className="top-1/3 right-[6%] text-pink-500 w-9 h-9 animate-float -rotate-12" style={{ animationDelay: "0.5s" }} />
    <Doodle icon={Heart} fill="#FF1493" className="bottom-10 right-[14%] text-pink-500 w-6 h-6 animate-wiggle" />
    <Doodle icon={Sun} fill="#FFD93D" className="top-1/2 left-[4%] text-yellow-400 w-8 h-8 animate-float" style={{ animationDelay: "1.4s" }} />
  </>
);
